export default "__VITE_ASSET__2c3ad35b__"